import React, {Component} from 'react'

import {Form, Header, Message} from 'semantic-ui-react';

export default class LoginForm extends Component {
    state = {
        username: '',
        password: ''
    }

    handleInputChange = event => {
        const target = event.target,
            value = target.type === 'checkbox'
                ? target.checked
                : target.value,
            name = target.name;
        this.setState({[name]: value});
    }

    onSubmit = event => {
        const {username, password} = this.state;
        event.preventDefault()
        this
            .props
            .tokenObtainPair(username, password)
    }

    render() {
        const {errors} = this.props;
        return <Form onSubmit={this.onSubmit}>
            <Header as='h1'>Authentication</Header>
            {
                errors.submit
                    ? <Message error={true}>
                            {errors.submit}
                        </Message>
                    : null
            }
            <Form.Group>
                <Form.Input
                    name="username"
                    label="Username"
                    error={!!errors.username}
                    onChange={this.handleInputChange}/> {
                    errors.username
                        ? <Message error={true}>
                                {errors.username}
                            </Message>
                        : null
                }
            </Form.Group>
            <Form.Group>
                <Form.Input
                    name="password"
                    label="Password"
                    error={!!errors.password}
                    type="password"
                    onChange={this.handleInputChange}/> {
                    errors.password
                        ? <Message error={true}>
                                {errors.password}
                            </Message>
                        : null
                }
            </Form.Group>
            <Form.Button content="Submit"/>
        </Form>;
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginForm.js